import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { STRIPE_PUBLISH_KEY } from '../../../src/env';
import { REFERRAL_ANNUAL } from '../../../utils/backend-api/subscribe';
import { CustomToaster } from '../../BaseUI';
import PaymentInfo from './PaymentInfo';
import PlanOptions from './PlanOptions';

const stripePromise = loadStripe(STRIPE_PUBLISH_KEY);

const queryClient = new QueryClient();

const Subscription = ({
  referringSubName,
  referringSubGuid,
  currentTrialEndDate,
  prefilledUserName,
  prefilledUserEmail,
}: {
  referringSubName: string;
  referringSubGuid: string;
  currentTrialEndDate: string;
  prefilledUserName?: string;
  prefilledUserEmail?: string;
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Elements stripe={stripePromise}>
        <CustomToaster />
        <PlanOptions referringSubName={referringSubName} />
        <PaymentInfo
          currentPlan={REFERRAL_ANNUAL}
          referringSubGuid={referringSubGuid}
          referringSubName={referringSubName}
          currentTrialEndDate={currentTrialEndDate}
          prefilledUserName={prefilledUserName}
          prefilledUserEmail={prefilledUserEmail}
        />
      </Elements>
    </QueryClientProvider>
  );
};

export default Subscription;
